import { Truck } from "@/components/common/svgs";
import { TranslatedText } from "@/components/common/text";
import { Link } from "@/components/common/links/Link";
import { homepageRoute } from "@/routing";

export const ErrorPage = ({ title, description }) => {
    return (
        <div className="flex flex-col items-center justify-center w-full h-full min-h-[calc(100vh-164px)] gap-6">
            <div className="mb-12">
                <Truck />
            </div>
            <h2 className="text-cm-text-primary text-[32px] leading-[50px] mb-2">
                <TranslatedText>{title}</TranslatedText>
            </h2>
            <div className="text-cm-text-tertiary text-xl leading-[31px] max-w-[841px] text-center mb-11">
                <TranslatedText>{description}</TranslatedText>
            </div>
            <div className="mt-1">
                <Link url={homepageRoute} className="min-w-[197px] h-[54px]">
                    Return to home
                </Link>
            </div>
        </div>
    );
};
